module.exports = __webpack_public_path__ + "static/media/logo__0013_David&Goliath.5e4a796d.png";